import { getEnvVar } from './helpers/'

export const API_MENU_SERVICE_ENDPOINT = getEnvVar(
  'VITE_API_MENU_SERVICE_ENDPOINT',
  window._env_
)

export const REACT_APP_SENTRY_DSN = getEnvVar(
  'VITE_REACT_APP_SENTRY_DSN',
  window._env_
)

export const SENTRY_TRACES_RATE = getEnvVar(
  'SENTRY_TRACES_RATE',
  window._env_,
  true
)
